export const selectSalesAnalyticsState = (state) => state.salesAnalytics || {};

export const selectSalesRestaurants = (state) =>
  state.salesAnalytics?.restaurants || [];

export const selectSalesRestaurantsLoading = (state) =>
  Boolean(state.salesAnalytics?.restaurantsLoading);

export const selectSalesRestaurantsLoaded = (state) =>
  Boolean(state.salesAnalytics?.restaurantsLoaded);

export const selectSalesAnalyticsData = (state) => state.salesAnalytics?.analytics;

export const selectSalesAnalyticsLoading = (state) =>
  Boolean(state.salesAnalytics?.loading);

export const selectSalesAnalyticsError = (state) => state.salesAnalytics?.error;

export const selectSalesAnalyticsActiveCacheKey = (state) =>
  state.salesAnalytics?.activeCacheKey;

export const selectSalesAnalyticsFromCache = (state) =>
  Boolean(state.salesAnalytics?.fromCache);

export const selectSalesAnalyticsFilters = (state) => ({
  dateRange: state.salesAnalytics?.dateRange,
  selectedRestaurantIds: state.salesAnalytics?.selectedRestaurantIds || [],
  groupBy: state.salesAnalytics?.groupBy || '',
  chartView: state.salesAnalytics?.chartView || 'bar',
});
